export default __webpack_public_path__ + "static/BG1-18883b64b82bdfa4444add3ff942dfe5.png";